import { useLocation } from 'react-router-dom';

import { NavigationTabs } from 'shared/ui/navigation-tabs';

import { TABS } from '../consts';

export function Tabs() {
  const location = useLocation();

  return <NavigationTabs tabs={TABS} rootPath={location.pathname} />;
}
